import styled from 'styled-components'

import pxToRem from '../../utils/pxToRem'
import ArrowRight from '../../images/icons/arrow-right-tile.svg'
import Image from '../Image/Image'
import Button from '../Button/Button'
import {deviceMax} from '../../theme/breakpoints'
import {HeroVariantEnum} from './Hero'
import Video from '../Video/Video'
import {NAVBAR_HEIGHT} from '../../theme/constants'

const BOX_SHADOW_COLOR = 'rgba(110, 140, 142, 0.11)'

export const StyledHeroHome = styled.div`
  position: relative;
  // 700px - 80px = 620px
  // 350px - 80 = 270px
  height: ${({$variant}) =>
          $variant === HeroVariantEnum.home ? pxToRem(620) : pxToRem(270)};
  @media ${deviceMax.tablet} {
    // 700px - 50px = 650px
    // 350px - 50 = 300px
    height: ${({$variant}) =>
            $variant === HeroVariantEnum.home ? pxToRem(650) : pxToRem(300)};
  }
  @media ${deviceMax.mobileL} {
    margin-bottom: ${pxToRem(30)};
    // 520px - 50px = 470px
    // 270px - 50 = 220px
    height: ${({$variant}) =>
            $variant === HeroVariantEnum.home ? 'auto' : $variant === HeroVariantEnum.investor ? pxToRem(300) : pxToRem(220)};
  }
`

export const StyledContentWrapper = styled.div`
  border: ${pxToRem(1)} solid ${({theme}) => theme.colors.unique.white};
  box-shadow: ${pxToRem(0)} ${pxToRem(0)} ${pxToRem(20)} ${BOX_SHADOW_COLOR};
  border-radius: ${pxToRem(5)} ${pxToRem(5)} ${pxToRem(40)} ${pxToRem(5)};
  padding: ${pxToRem(20)} ${pxToRem(20)} ${pxToRem(20)} ${pxToRem(20)};
  width: ${({$variant}) =>
          $variant === HeroVariantEnum.home ? '40%' : 'fit-content'};
  background: ${({theme}) => theme.colors.opacity.white20};
  @media ${deviceMax.laptop} {
    width: ${({$variant}) =>
            $variant === HeroVariantEnum.home ? '60%' : 'fit-content'};
  }
  @media ${deviceMax.mobileL} {
    width: ${({$variant}) =>
            $variant === HeroVariantEnum.home ? 'auto' : 'fit-content'};
  }
`
export const StyledContainer = styled.div`
  justify-content: space-between;
  align-items: center;
  display: flex;
  margin: 0 ${pxToRem(100)};
  margin-top: ${({$variant}) =>
          $variant === HeroVariantEnum.home ? pxToRem(103) : pxToRem(40)};

  @media ${deviceMax.laptop} {
    margin-left: ${pxToRem(50)};
  }
  @media ${deviceMax.tablet} {
    margin: 0 ${pxToRem(50)};
    margin-top: ${pxToRem(70)};
  }
  @media ${deviceMax.mobileL} {
    align-items: flex-start;
    flex-direction: column;
    padding: ${({$variant}) =>
            $variant === HeroVariantEnum.home ? '0' : `${pxToRem(20)} 0 0 0`};
    margin: ${({$variant}) =>
            $variant === HeroVariantEnum.home
                    ? `${pxToRem(40)} ${pxToRem(10)} 0`
                    : $variant === HeroVariantEnum.investor
                            ? `0`
                            : `${pxToRem(40)} 0`};
  }
`

export const StyledIFrame = styled.iframe`
  width: ${pxToRem(260)};
  height: ${pxToRem(125)};
  @media ${deviceMax.mobileL} {
    margin-left: auto;
  }
`

export const StyledContent = styled.div`
  position: relative;
  border-radius: ${pxToRem(5)} ${pxToRem(5)} ${pxToRem(40)} ${pxToRem(5)};
  padding: ${pxToRem(40)};
  background-color: ${({theme}) => theme.colors.opacity.white60};
  backdrop-filter: blur(${pxToRem(10)});
  @media ${deviceMax.tablet} {
    padding: ${pxToRem(20)};
  }
`

export const StyledTitle = styled.div`
  position: relative;
`

export const StyledTitleMarker = styled.span`
  position: relative;
  display: block;

  &:before {
    content: '';
    position: absolute;
    top: ${pxToRem(15)};
    right: 0;
    left: 0;
    transform: translateX(-${pxToRem(135)});
    width: ${pxToRem(127)};
    height: ${pxToRem(2)};
    background-color: ${({theme}) => theme.colors.unique.black};
    @media ${deviceMax.laptop} {
      transform: translateX(-${pxToRem(90)});
      width: ${pxToRem(80)};
    }
    @media ${deviceMax.tablet} {
      transform: translateX(-${pxToRem(70)});
      width: ${pxToRem(60)};
    }
    @media ${deviceMax.mobileL} {
      top: ${pxToRem(10)};
      transform: translateX(-${pxToRem(30)});
      width: ${pxToRem(19)};
    }
  }
`

export const StyledDescription = styled.p`
  margin-top: ${pxToRem(30)};
  font-size: ${({theme}) => theme.fonts.sizes.base};
  font-weight: ${({theme}) => theme.fonts.weight.normal};
  line-height: ${({theme}) => theme.fonts.lineHeight.base};
  @media ${deviceMax.tablet} {
    margin-top: ${pxToRem(20)};
  }
`

export const StyledButtonsContainer = styled.div`
  justify-content: flex-start;
  flex-wrap: wrap;
  display: flex;
`

export const StyledButton = styled(Button)`
  margin-top: ${pxToRem(30)};
  margin-right: ${pxToRem(30)};
  text-align: center;
  @media ${deviceMax.tablet} {
    margin-top: ${pxToRem(20)};
    margin-right: ${pxToRem(20)};
  }
`

export const StyledImageWrapper = styled.div`
  position: absolute;
  z-index: -1;
  top: -${pxToRem(NAVBAR_HEIGHT.desktop)};
  right: 0;
  left: 0;
  overflow: hidden;
  display: block;

  @media ${deviceMax.tablet} {
    top: -${pxToRem(NAVBAR_HEIGHT.mobile)};
    height: calc(100% + ${pxToRem(NAVBAR_HEIGHT.mobile)} + ${pxToRem(30)});
  }

  * {
    border-radius: 0 0 0 ${pxToRem(50)};
    margin-left: ${pxToRem(270)};
    width: 100%;
    height: ${({$variant}) =>
            $variant === HeroVariantEnum.home ? pxToRem(700) : pxToRem(350)};
    object-fit: cover;
    @media ${deviceMax.laptop} {
      margin-left: ${pxToRem(166)};
    }
    @media ${deviceMax.tablet} {
      margin-left: ${pxToRem(140)};
    }
    @media ${deviceMax.mobileL} {
      margin-left: ${pxToRem(51)};
      height: ${({$variant}) =>
              $variant === HeroVariantEnum.home ? pxToRem(520) : $variant === HeroVariantEnum.investor ? pxToRem(340) : pxToRem(270)};
    }

    @media ${deviceMax.mobileS} {
      height: ${({$variant}) =>
              $variant === HeroVariantEnum.home ? pxToRem(520) : $variant === HeroVariantEnum.investor ? pxToRem(355) : pxToRem(270)};
    }
  }
`

export const StyledPlaceholder = styled.div`
  border-radius: 0 0 0 ${pxToRem(50)};
  margin-left: ${pxToRem(270)};
  width: 100%;
  height: ${({$variant}) =>
          $variant === HeroVariantEnum.home ? pxToRem(700) : pxToRem(350)};
  background-color: ${({$backgroundColor, theme}) =>
          $backgroundColor ? $backgroundColor : theme.colors.unique.black};
  @media ${deviceMax.laptop} {
    margin-left: ${pxToRem(166)};
  }
  @media ${deviceMax.tablet} {
    margin-left: ${pxToRem(140)};
  }
  @media ${deviceMax.mobileL} {
    margin-left: ${pxToRem(51)};
    height: ${({$variant}) =>
            $variant === HeroVariantEnum.home ? pxToRem(520) : $variant === HeroVariantEnum.investor ? pxToRem(340) : pxToRem(270)};
  }
  @media ${deviceMax.mobileS} {
    height: ${({$variant}) =>
            $variant === HeroVariantEnum.home ? pxToRem(520) : $variant === HeroVariantEnum.investor ? pxToRem(350) : pxToRem(270)};
  }
`

export const StyleIcon = styled(ArrowRight)`
  margin-left: ${pxToRem(10)};
  width: ${pxToRem(18)};
  height: ${pxToRem(18)};
  padding: ${pxToRem(3)} ${pxToRem(3)};
  border: ${pxToRem(1)} solid ${({theme}) => theme.colors.unique.black};
  border-radius: ${pxToRem(5)};
  vertical-align: middle;
`

export const StyledImage = styled(Image)`
  border-radius: 0 0 0 ${pxToRem(50)};
  margin-left: ${pxToRem(270)};
  width: 100%;
  height: ${({$variant}) =>
          $variant === HeroVariantEnum.home ? pxToRem(700) : pxToRem(350)};
  object-fit: cover;
  @media ${deviceMax.laptop} {
    margin-left: ${pxToRem(166)};
  }
  @media ${deviceMax.tablet} {
    margin-left: ${pxToRem(140)};
  }
  @media ${deviceMax.mobileL} {
    margin-left: ${pxToRem(51)};
    height: ${({$variant}) =>
            $variant === HeroVariantEnum.home ? 'calc(100% + 10px)' : $variant === HeroVariantEnum.investor ? pxToRem(340) : pxToRem(270)};
  }
  @media ${deviceMax.mobileS} {
    height: ${({$variant}) =>
            $variant === HeroVariantEnum.home ? 'calc(100% + 10px)' : $variant === HeroVariantEnum.investor ? pxToRem(350) : pxToRem(270)};
  }
`
export const StyledVideo = styled(Video)`
  border-radius: 0 0 0 ${pxToRem(50)};
  margin-left: ${pxToRem(270)};
  width: 100%;
  height: ${({$variant}) =>
          $variant === HeroVariantEnum.home ? pxToRem(700) : pxToRem(350)};
  object-fit: cover;
  @media ${deviceMax.laptop} {
    margin-left: ${pxToRem(166)};
  }
  @media ${deviceMax.tablet} {
    margin-left: ${pxToRem(140)};
  }
  @media ${deviceMax.mobileL} {
    margin-left: ${pxToRem(51)};
    height: ${({$variant}) =>
            $variant === HeroVariantEnum.home ? pxToRem(520) : $variant === HeroVariantEnum.investor ? pxToRem(340) : pxToRem(270)};
  }
  @media ${deviceMax.mobileS} {
    height: ${({$variant}) =>
            $variant === HeroVariantEnum.home ? pxToRem(520) : $variant === HeroVariantEnum.investor ? pxToRem(355) : pxToRem(270)};
  }
`
